import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

function resizeOnOverflow(swiper){
    const isOverflow = swiper.size < swiper.virtualSize;
    swiper.wrapperEl.style.justifyContent = isOverflow ? 'normal' : 'center';
}
function initCarousels(selector){
    document.querySelectorAll(selector).forEach(el => {
        if (!el.dataset.slider){
            return;
        }
        try{
            const sliderSettings = JSON.parse(el.dataset.slider);
            if (!sliderSettings.slides){
                return;
            }

            let options = {
                autoplay: false,
                modules: [Navigation],
                slidesPerView: sliderSettings.slides,
                preloadImages: false,
                watchSlidesProgress: true,
                spaceBetween: 24,
                breakpoints: {},
                // allowTouchMove: false,
                lazy: {
                    enabled: true,
                    loadPrevNext: true,
                    checkInView: true
                },
                // watchSlidesProgress: true,
                navigation: {
                    nextEl: '.swipe-next',
                    prevEl: '.swipe-prev',
                },
            }

            if (el.dataset.position === 'center'){
                options.on = {
                    resize: function (){
                        resizeOnOverflow(this);
                    },
                    init: function (){
                        resizeOnOverflow(this)
                    }
                }
            }

            if (sliderSettings.br){
                sliderSettings.br.forEach((row) => {
                    options.breakpoints[row[0]] = {
                        slidesPerView: row[1],
                        slidesPerGroup: parseInt(row[1]),
                        spaceBetween: (row[0] >= 1024) ? 24 : 16
                    };
                })
            }

            new Swiper(el, options);

        }catch (e){
            return;
        }

    })
}

function initFeatured(){
    if (!document.querySelector('.featured')){
        return;
    }
    let autoplay = {
        delay: 5000
    }
    let loop = true;
    if (document.querySelectorAll('.featured .swiper-slide').length <= 1){
        autoplay = false;
        loop = false;
    }
    new Swiper('.featured', {
        modules: [Navigation, Pagination, Autoplay],
        // Optional parameters
        loop: loop,
        speed: 800,
        lazy: {
            enabled: true,
            loadPrevNext: true,
            checkInView: true
        },
        pagination: {
            el: ".swiper-paginations",
            clickable: true,
            bulletClass: 'ft-swiper-bullet',
            bulletActiveClass: 'ft-swiper-bullet-active',
            horizontalClass: 'fite-swiper-pagination',
            modifierClass: 'fite-swiper-'
        },
        navigation: {
            nextEl: '.swipe-next',
            prevEl: '.swipe-prev',
        },
        autoplay: autoplay,
    });
}


export {initCarousels, initFeatured};
